import { HeaderState } from '../objects/headerState';
import { HeaderActionTypes, SET_CONFIG, SET_GOOGLE, UPDATE_QUOTA } from './actionTypes';

const initialState: HeaderState = {
    actual_active_agency: 0,
    actual_users: 0,
    agency_quota: 0,
    client_id: null,
    favicon: null,
    google: null,
    keys: [],
    logo: null,
    quotation_code: null,
    quota_active_agency: 0,
    quota_user_bo: 0,
    retrieved: false,
    user_quota: 0,
    agency_group: null,
    has_crm: false,
    has_cms: false
};

export default (state = initialState, action: HeaderActionTypes): HeaderState => {
    switch (action.type) {
        case SET_CONFIG: {
            const { client_id, logo, keys, favicon, quota_users_bo, quotation_code, agency_group, has_crm, has_cms } = action.payload;
            return {
                ...state,
                client_id: client_id,
                favicon: favicon,
                keys: keys,
                logo: logo,
                retrieved: true,
                user_quota: quota_users_bo,
                quotation_code: quotation_code,
                // quotation_code: 'mci',
                agency_group: agency_group || null,
                has_crm: !!has_crm,
                has_cms: !!has_cms
            };
        }
        case SET_GOOGLE: {
            return { ...state, google: action.payload };
        }
        case UPDATE_QUOTA: {
            const { actual_active_agency, actual_users, quota_active_agency, quota_user_bo } = action.payload;
            return {
                ...state,
                actual_active_agency: actual_active_agency,
                actual_users: actual_users,
                quota_active_agency: quota_active_agency,
                quota_user_bo: quota_user_bo
            };
        }
        default:
            return state;
    }
};